import Spinner from 'react-bootstrap/Spinner';

const SpinnerIcon = () => {
  return (
    <Spinner animation="border" role="status" style={{ color: "#e93864", height: "25px", width: "30px", margin: "auto 5px auto auto"}}>
        <span className="visually-hidden">Loading...</span>
    </Spinner>
  );
}

export default SpinnerIcon;